module.exports = __webpack_public_path__ + "img/s6-dialog2.94baebdd.png";